import api from '@/services/api';

const UserQuery = {
  getCompanyUserList: () => {
    return api.get('get_company_user_list/');
  },
  getUserDetail: () => {
    return api.get('get_user_detail/');
  },
  getUsedUploadFileBytes: () => {
    return api.get('get_used_upload_file_bytes/');
  }
};

export default UserQuery;
